import { Box, Container, Skeleton } from "@mui/material";
import "./home-skeleton.scss";

const HomeSkeleton = () => {
  return (
    <Box className="home-skeleton" aria-label="Loading home page">
      <Container maxWidth="xl" className="home-skeleton__hero">
        <Skeleton
          variant="rounded"
          className="home-skeleton__float home-skeleton__float--top-left"
        />
        <Skeleton
          variant="rounded"
          className="home-skeleton__float home-skeleton__float--bottom-left"
        />
        <Skeleton
          variant="rounded"
          className="home-skeleton__float home-skeleton__float--top-right"
        />
        <Skeleton
          variant="rounded"
          className="home-skeleton__float home-skeleton__float--bottom-right"
        />

        <Box className="home-skeleton__copy">
          <Skeleton variant="text" className="home-skeleton__eyebrow" />
          <Skeleton variant="text" className="home-skeleton__title" />
          <Skeleton variant="text" className="home-skeleton__title home-skeleton__title--short" />
          <Skeleton variant="text" className="home-skeleton__body" />
          <Skeleton variant="text" className="home-skeleton__body home-skeleton__body--short" />
          <Skeleton variant="rounded" className="home-skeleton__button" />
        </Box>
      </Container>

      <Box className="home-skeleton__showcase">
        <Box className="home-skeleton__tabs">
          <Skeleton variant="rounded" />
          <Skeleton variant="rounded" />
          <Skeleton variant="rounded" />
        </Box>
        <Skeleton variant="text" className="home-skeleton__caption" />
        <Skeleton variant="rounded" className="home-skeleton__video" />
      </Box>
    </Box>
  );
};

export default HomeSkeleton;
